<template>
  <div class="order">
    <div class="content address_content" @click="goaddress">
      <p class="address_name">
        <span>{{ address.nickname }}</span>
        <span>{{ address.phone }}</span>
      </p>
      <p class="address_add">
        {{ getArea(address.area) }}&nbsp;{{ address.address }}
      </p>
    </div>
    <div class="prescription-content">
      <p class="title">{{objData.name}}</p>
      <p class="prescription"><span v-for="(medicine,index) in objData.content" :key="index">{{medicine.name}}{{medicine.quantity}}{{unitFormat(medicine.unit)}} </span></p>
      <div class="num">
        帖数：
        <span class="reduce" :class="objData.num < 2?'grey':''" @click="handleReduce"></span>
        <input type="number" min="1" v-model="objData.num" />
        <span class="plus" @click="handlePlus"></span>
      </div>
    </div>
    <div class="content distribution_content" @click="show_express = true">
      <p class="content_title">
        配送
        <span class="distribution_p1">{{
          distribution[export_index].name
        }}</span>
      </p>
      <p class="distribution_p2">{{ distribution[export_index].details }}</p>
    </div>

    <div class="content charging_content">
      <p class="charging_p1">
        药费
        <span>￥{{priceFormat(objData.price, objData.num)}}</span>
      </p>
      <p class="charging_p1">
        运费（满百包邮）
        <span :class="objData.price*objData.num >= 100 ? 'del_active' : ''"
          >￥{{ charging.freight }}</span
        >
      </p>

      <p class="charging_p2">
        合计
        <span>￥{{ totalFormat(objData.price, objData.num, charging.freight) }}</span>
      </p>
    </div>
    <div class="submit_content">
      <button class="buynow" @click="show_pay = true">立即支付</button>
    </div>
    <!-- 快递选择弹窗 -->
    <van-popup
      class="express_content"
      v-model="show_express"
      position="bottom"
      round
      :style="{ height: '30%' }"
    >
      <p class="express_head">
        <span class="express_cancel" @click="show_express = false">取消</span>
        选择配送方式
        <span
          class="express_determine"
          @click="
            (export_index = pre_export_index),
              (show_express = false),
              getmoney()
          "
          >确定</span
        >
      </p>
      <ul class="express_ul">
        <li
          v-for="(item, index) in distribution"
          :key="index"
          class="express_li"
          @click="pre_export_index = index"
        >
          <img
            :src="require('../../assets/images/order/icon' + index + '.png')"
            alt
          />
          <p>
            {{ item.name }}
            <br />
            <span>{{ item.details }}</span>
          </p>
          <div
            :class="[
              { express_icon_active: index == pre_export_index },
              'express_icon',
            ]"
          ></div>
        </li>
      </ul>
    </van-popup>
    <!-- 支付选择弹窗 -->
    <van-popup
      class="express_content"
      v-model="show_pay"
      position="bottom"
      round
      :style="{ height: '85%' }"
    >
      <p class="express_head">
        <span class="express_cancel" @click="show_pay = false">取消</span>
        选择支付方式
      </p>
      <ul class="express_ul">
        <li
          v-for="(item, index) in payment"
          :key="index"
          class="express_li"
          @click="pre_pay_index = index"
          v-show="item.isshow"
        >
          <img
            :src="
              require('../../assets/images/order/pay_icon' + index + '.png')
            "
            alt
          />
          <p class="pay_p">{{ item.name }}</p>
          <div
            :class="[
              { express_icon_active: index == pre_pay_index },
              'express_icon',
            ]"
          ></div>
        </li>
      </ul>
      <button class="buynow" @click="orderup">确认</button>
    </van-popup>
  </div>
</template>
<script>
import { deviceType } from "../../util/deviceType";
import { Toast } from 'vant';
import http from "../../util/pontusApiConfig";
import http2 from "../../util/gaeaApiConfig";

export default {
  data() {
    return {
      listData: {},
      address: {},
      pharmacy: {
        name: "北京·康美药业",
        detail: "专业从事中药配方颗粒研究和生产15年",
        tips: "17:00前下单，当日寄出",
      },
      show_express: false,
      export_index: 0,
      pre_export_index: 0,
      distribution: [
        {
          name: "顺丰快递",
          details: "药费满¥100包邮，90%地区次日送达",
          money: 0,
        },
      ],
      show_pay: false,
      pre_pay_index: 0,
      payment: [
        {
          name: "支付宝支付",
          isshow: true,
        },
        {
          name: "微信支付",
          isshow: true,
        },
      ],
      // 是否提供代煎选择
      isprovide: true,
      // 是否代煎
      isdecocting: false,
      // 可以代煎
      candecocting: false,
      amountOfMoney: 0,
      charging: {
        // 药费
        drugcost: 0,
        // 运费
        freight: 15,
        // 优惠费
        discount: 0,
        // 代煎费
        decoctingfee: 0,
      },
      is_choise_coupon: 3,
      coupon_count: 0,
      // 供应商id
      provider_id: null,
      user_id: 1,
      order_id: 2,
      openid: false,
      token: "",
      appid: "wxcc7ab5ca954203d8",
      is_weixin: deviceType.isWeiXin,
      is_app: deviceType.isApp,
      is_ios_app: deviceType.isIOSApp,
      is_android_app: deviceType.isAndroidApp,
      is_Patient: deviceType.isPatient,
      objData: {}
    };
  },
  created() {
    var user_info = this.$appUtils.appData();
    if (user_info) {
      this.user_id = user_info.user_id;
      this.token = user_info.token;
    } else {
      this.user_id = localStorage.getItem("user_id");
      this.token = localStorage.getItem("token");
    }
    if (this.$route.query.obj) {
      this.objData = JSON.parse(this.$route.query.obj);
    }
    console.log(this.objData)
    if (localStorage.getItem("user_id")) {
      this.user_id = localStorage.getItem("user_id");
    }
    if (localStorage.getItem("token")) {
      this.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("openid")) {
      this.openid = localStorage.getItem("openid");
    }
    if (this.is_weixin && !this.openid) {
      this.payment[0].isshow = false;
      let code = this.$route.query.code;
      if (code) {
        this.getOpenid(code);
      } else {
        let redirectUrl = window.location.href;
        redirectUrl = encodeURIComponent(redirectUrl);
        let url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.appid +
          "&redirect_uri=" +
          redirectUrl +
          "&response_type=code&scope=snsapi_userinfo&state=type%wechat_redirect";
        window.location.href = url;
      }
    }
    if (localStorage.getItem("address_id")) {
      this.getaddress();
    } else {
      this.getdefault_address();
    }
    this.$appUtils.appCloseLoadingView();
    window.appBack = () => this.pageback();
  },
  methods: {
    priceFormat(price, num){
        return (price*num).toFixed(2);
    },
    totalFormat(price, num, postage){
        price = price*num;
        if(price < 100){
          price = price + postage
        }
        return price.toFixed(2);
    },
    handleReduce(){
      this.objData.num = parseInt(this.objData.num) - 1;
      if(this.objData.num < 2) this.objData.num = 1;
    },
    handlePlus(){
      this.objData.num = parseInt(this.objData.num) + 1;
    },
    unitFormat(unit){
        if(unit == '克'){
            return 'g';
        }
        return unit;
    },
    getArea(arr) {
      let str = "";
      if (arr) {
        arr = JSON.parse(arr);
        // console.log(arr);
        for (let i = 0; i < arr.length; i++) {
          if (i == 0) {
            str = arr[i]["name"];
          } else {
            str = str + " " + arr[i]["name"];
          }
          if (i == 1) {
            if (
              arr[i].id == 230 &&
              arr[i].code == "440100" &&
              arr[i].name == "广州市"
            ) {
              this.distribution[0].money = 10;
              this.charging.freight = 10;
            } else {
              this.distribution[0].money = 20;
              this.charging.freight = 20;
            }
          }
        }
      }
      return str;
    },
    getaddress(num) {
      let that = this;
      http2
        .get("/users/" + that.user_id + "/addresses", {
          headers: {
            Authorization: that.token,
          },
        })
        .then(function (res) {
          // console.log(res)
          if (res.data.status_code == 200) {
            for (let i = 0; i < res.data.data.addresses.length; i++) {
              if (
                res.data.data.addresses[i].address_id ==
                localStorage.getItem("address_id")
              ) {
                that.address = res.data.data.addresses[i];
                break;
              }
            }
            if (num == 1 && JSON.stringify(that.address) == "{}") {
              that.address = res.data.data.addresses[0];
            }
          }
        });
    },
    getdefault_address() {
      let that = this;
      http2
        .get("/users/" + that.user_id + "/default_address", {
          headers: {
            Authorization: that.token,
          },
        })
        .then(function (res) {
          // console.log(res)
          if (res.data.status_code == 200) {
            that.address = res.data.data;
            if (JSON.stringify(that.address) == "{}") {
              that.getaddress(1);
            }
          }
        });
    },
    goaddress() {
      this.$router.push({
        path: "addresslist",
        query: {
          t: 1,
        },
      });
    },
    getmoney() {
      let money = this.charging.drugcost;
      this.charging.freight = this.distribution[this.export_index].money;
      // 代煎
      if (this.isdecocting && this.isprovide) {
        this.charging.decoctingfee = this.listData.prescription.total_count * 2;
        money += this.charging.decoctingfee;
      }
      // 满百免邮
      if (this.charging.drugcost < 100) {
        money += this.charging.freight;
      }
      // 优惠减价
      if (this.charging.discount > 0) {
        money -= this.charging.discount;
      }
      this.amountOfMoney = money;
      // console.log(money);
    },
    orderup() {
      let that = this;
      if(!this.address.area){
        Toast('请选择收货地址！');
        return false;
      }
      let area = this.getArea(this.address.area) + " " + this.address.address;
      let postage = 0;
      if(this.objData.price * this.objData.num < 100){
        postage = this.charging.freight;
      }
      let params = {
        order_type: "drug",
        address: area,
        addressee: this.address.nickname,
        phone: this.address.phone,
        name: this.objData.name,
        content: JSON.stringify(this.objData.content),
        num: this.objData.num,
        postage: postage,
        return_url: window.location.origin + "/medicineorderresult",
      };
      if(this.is_ios_app){
        params['channel'] = 'ios';
      }else if(this.is_android_app){
        params['channel'] = 'android';
      }else{
        params['channel'] = 'wap';
      }
      if (this.is_app) {
        if (this.pre_pay_index == 0) {
          params["scene"] = 1;
          params["pay_type"] = "ali_app";
        } else {
          params["scene"] = 0;
          params["pay_type"] = "wx_app";
        }
        params['return_url'] = window.location.origin + "/medicineorderdetail"
        that.$appUtils.appPay(params);
      } else {
        if (this.pre_pay_index == 0) {
          params["pay_type"] = "ali_wap";
        } else {
          if (this.is_weixin) {
            params["pay_type"] = "wx_js";
            params["openid"] = this.openid;
          } else {
            params["pay_type"] = "wx_h5_wap";
          }
        }
        this.toPay(params);
      }
    },
    getOpenid(code) {
      let that = this;
      let params = { code: code };
      http2.get("/users/oauth/user", { params: params }).then(function (res) {
        if (res.data.status_code == 200) {
          that.openid = res.data.data.openid;
          localStorage.setItem("openid", that.openid);
        }
      });
    },
    toPay(params) {
      let that = this;
      //  / users/"+that.user_id+"/order
      http
        .post("/users/" + that.user_id + "/order", params, {
          headers: { Authorization: that.token },
        })
        .then(function (res) {
          console.log(res);
          if (res.data.status_code == 200) {
            localStorage.setItem("out_trade_no", res.data.data.out_trade_no);
            if (params["pay_type"] == "ali_wap") {
              window.location.href = res.data.data.pay_params;
            } else if (params["pay_type"] == "wx_h5_wap") {
              window.location.href =
                res.data.data.pay_params.mweb_url +
                "&redirect_url=" +
                params["return_url"];
            } else if (params["pay_type"] == "wx_js") {
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data.pay_params),
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent(
                    "WeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data.pay_params)
                  );
                  document.attachEvent(
                    "onWeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data.pay_params)
                  );
                }
              } else {
                that.onBridgeReady(res.data.data.pay_params);
              }
            }
          }
        });
    },
    onBridgeReady(data) {
      let that = this;
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, // 公众号名称，由商户传入
          timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, // 随机串
          package: data.package,
          signType: data.signType, // 微信签名方式：
          paySign: data.paySign, // 微信签名
        },
        function (res) {
          // alert(JSON.stringify(res));
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            window.location.href = window.location.origin + "/medicineorderresult";
          }
        }
      );
    },
    pageback() {
      if(this.$route.query.t){
        window.history.back();
        return true;
      }else{
        return null;
      }

    },
  },
  watch: {
    isdecocting(val) {
      this.getmoney();
    },
  },
};
</script>
<style lang="scss" scoped>
.prescription-content{
  width: calc(100% - 50px);
  margin: 0 auto 10px;
  padding: 20px 10px;
  background-color: #ffffff;
  box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
  border-radius: 10px;
  .title{
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #666666;
  }
  .prescription{
    margin-top: 10px;
    padding-bottom: 7px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #f2f2f2;
  }
  .num{
    margin-top: 20px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    position: relative;
    input{
      padding: 0;
      width: 28px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      color: #AC4B38;
      text-align: center;
      background: #EDEDED;
      border: 0;
      border-radius: 0;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 26px;
    }
    .reduce,
    .plus{
      display: block;
      width: 24px;
      height: 24px;
      background: #EDEDED;
      border-radius: 2px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      cursor: pointer;
    }
    .reduce{
      right: 56px;
    }
    .plus{
      right: 0;
    }
    .reduce::before,
    .plus::before{
      content: '';
      display: block;
      width: 12px;
      height: 1px;
      background: #4D4D4D;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .plus::after{
      content: '';
      display: block;
      width: 1px;
      height: 12px;
      background: #4D4D4D;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .grey::before{
      background: #999999;
    }
  }
}
.order {
  padding-top: 10px;
  .content {
    width: calc(100% - 30px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 10px;
    margin: 0 auto;
    margin-bottom: 10px;
    color: #333;
    .content_title {
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      .distribution_p1 {
        font-size: 14px;
        float: right;
        margin-right: 17px;
        &::after {
          content: "";
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-left: 6px;
          background: url("../../assets/images/order/more.png") no-repeat center
            center;
          background-size: cover;
          vertical-align: text-top;
        }
      }
    }
  }
  .address_content {
    height: 80px;
    padding-left: 60px;
    position: relative;
    background: url("../../assets/images/order/address_icon.png") no-repeat 10px
      center;
    background-size: 40px 40px;
    p {
      width: 100%;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .address_add {
      color: #666;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 16px;
      height: 16px;
      top: calc(50% - 8px);
      right: 5px;
      background: url("../../assets/images/order/more.png") no-repeat center
        center;
      background-size: cover;
    }
  }
  .pharmacy_content {
    .pharmacy_content2 {
      width: 100%;
      box-sizing: border-box;
      padding-left: 54px;
      margin-top: 10px;
      background: url("../../assets/images/order/yaofang.png") no-repeat 0px 5px;
      background-size: 44px 44px;
      .pharmacy_p1 {
        font-size: 14px;
        color: #333;
        ins{
          width: 12px;
          height: 12px;
          display: inline-block;
          background: url('../../assets/images/order/i.png') no-repeat center center;
          background-size: cover;
          margin-left: 5px;
        }
        font-weight: 500;
      }
      .pharmacy_p2 {
        font-size: 12px;
        color: #999;
        margin-top: 3px;
      }
      .decocting_chiose {
        display: flex;
        justify-content: space-between;
        margin-top: 9px;
        .chiose_p {
          width: 128px;
          height: 40px;
          line-height: 40px;
          color: #999999;
          font-size: 12px;
          box-shadow: 0px -1px 0px 0px rgba(244, 244, 244, 1);
          border-radius: 8px;
          border: 1px solid rgba(153, 153, 153, 1);
          text-align: center;
        }
        .diy_active {
          border: 1px solid #ac4b38;
          background: #fff2f0;
          color: #ac4b38;
        }
        .diy_active.chiose_p1::before {
          background: url("../../assets/images/order/diy_pre.png") no-repeat
            center center;
          background-size: cover;
        }
        .diy_active.chiose_p2::before {
          background: url("../../assets/images/order/medicine_pre.png")
            no-repeat center center;
          background-size: cover;
        }
        .chiose_p1 {
          &::before {
            content: "";
            width: 24px;
            height: 24px;
            display: inline-block;
            background: url("../../assets/images/order/diy_nor.png") no-repeat
              center center;
            background-size: cover;
            vertical-align: middle;
            margin-right: 12px;
          }
        }
        .chiose_p2 {
          &::before {
            content: "";
            width: 24px;
            height: 24px;
            display: inline-block;
            background: url("../../assets/images/order/medicine_nor.png")
              no-repeat center center;
            background-size: cover;
            vertical-align: middle;
            margin-right: 12px;
          }
        }
      }
    }
  }
  .distribution_content {
    .distribution_p2 {
      font-size: 12px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      text-align: right;
      padding-right: 17px;
    }
  }
  .prescription_content {
    background: url("../../assets/images/order/background_prescription.png")
      no-repeat top center;
    background-size: 100% 92px;
    .personal {
      height: 92px;
      padding: 37px 10px 14px 10px;
      box-sizing: border-box;
      // background: rgba(255, 242, 242, 1);
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      position: relative;
      border-radius: 8px 8px 0px 0px;
      &::before {
        content: "处方";
        width: 100%;
        display: block;
        text-align: center;
        position: absolute;
        top: 0px;
        font-size: 16px;
      }
    }
    .content2 {
      padding-bottom: 12px;
      border-bottom: 1px solid #fef2f0;
      .head_title {
        width: 100%;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        margin-top: 12px;
        margin-bottom: 6px;
        &::before {
          content: "";
          display: block;
          width: 4px;
          height: 16px;
          background: #de654c;
          position: absolute;
          top: 4px;
          left: -10px;
        }
        .ask {
          float: right;
          padding: 4px 8px;
          border-radius: 4px;
          text-align: center;
          font-size: 12px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #ac4b38;
          line-height: 17px;
          &::before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 15px;
            background: url("../../assets/images/order/msg.png") no-repeat
              center center;
            background-size: cover;
            vertical-align: text-top;
            margin-right: 5px;
          }
        }
      }
      .content_details {
        font-size: 14px;
        line-height: 21px;
        color: #666;
        .medicament_li {
          display: inline-block;
          margin-right: 6px;
        }
      }

      .medicament_li_tips1 {
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #999999;
        line-height: 25px;
        text-align: center;
      }
      .medicament_li_tips2 {
        padding: 20px 0px;
      }
    }
  }
  .bn {
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }
  .detail_content {
    .detail_p1 {
      font-size: 12px;
      margin-bottom: 10px;
      color: #999999;
      span {
        float: right;
      }
    }
  }
  .charging_content {
    .charging_p1 {
      font-size: 14px;
      margin-bottom: 10px;
      color: #333333;
      margin-bottom: 13px;
      span {
        float: right;
      }
      .del_active {
        text-decoration: line-through;
      }
      .coupon_count {
        color: #ac4b38;
        &::after {
          content: "";
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-left: 2px;
          background: url("../../assets/images/order/more.png") no-repeat center
            center;
          background-size: cover;
          vertical-align: text-top;
        }
      }
      .no_coupon {
        color: #999;
      }
    }
    .charging_p2 {
      margin-top: 15px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      span {
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        float: right;
        color: #ac4b38;
      }
    }
  }
  .order_content {
    .dorctor_name {
      font-size: 14px;
    }
    .dorctor_time {
      margin-top: 14px;
      font-size: 12px;
      color: #999999;
    }
  }
  .submit_content {
    width: 100%;
    height: 70px;
    padding: 10px 15px;
    box-sizing: border-box;
    border-top: 1px solid #e4e4e4;
    .submit_money {
      font-size: 14px;
      line-height: 40px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      display: inline-block;
      span {
        font-weight: bold;
        font-size: 24px;
      }
    }
    .submit_button {
      border: none;
      width: 120px;
      height: 40px;
      background: rgba(172, 75, 56, 1);
      border-radius: 10px;
      text-align: center;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 25px;
      float: right;
    }
  }
  .express_content {
    background-color: #f8f8f8;
    .express_head {
      background-color: #fff;
      width: 100%;
      height: 60px;
      line-height: 60px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
      position: relative;
      .express_cancel,
      .express_determine {
        display: inline-block;
        padding: 0px 15px;
        height: 60px;
        font-size: 14px;
        position: absolute;
        top: 0;
      }
      .express_cancel {
        color: #999;
        left: 0;
      }
      .express_determine {
        color: #ac4b38;
        right: 0;
      }
    }
    .express_ul {
      width: 100%;
      box-sizing: border-box;
      padding: 0px 15px;
      .express_li {
        width: 100%;
        height: 60px;
        border-radius: 8px;
        background: #fff;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 15px 12px;
        display: flex;
        img {
          display: block;
          width: 30px;
          height: 30px;
        }
        p {
          width: calc(100% - 60px);
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          line-height: 16px;
          margin-left: 10px;
          span {
            color: #999;
            font-size: 12px;
          }
        }
        .pay_p {
          line-height: 30px;
        }
        .express_icon {
          width: 20px;
          height: 20px;
          background: url("../../assets/images/order/express_nor.png") no-repeat
            center center;
          background-size: cover;
          margin-top: 5px;
        }
        .express_icon_active {
          background: url("../../assets/images/order/express_pre.png") no-repeat
            center center;
          background-size: cover;
        }
      }
    }
  }
  .buynow {
    width: calc(100% - 40px);
    height: 48px;
    background: rgba(172, 75, 56, 1);
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    border: none;
    margin: 0 auto;
  }
  .submit_content .buynow {
    width: 100%;
  }
  .express_content .buynow {
    position: fixed;
    bottom: 10px;
    left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/medicineorder.vue